import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import deDE from './locales/de-DE'
import ptPT from './locales/pt-PT'
import esES from './locales/es-ES'
import frFR from './locales/fr-FR'
import itIT from './locales/it-IT'
import ruRU from './locales/ru-RU'
import koKR from './locales/ko-KR'
import jaJP from './locales/ja-JP'
import arSA from './locales/ar-SA'
import thTH from './locales/th-TH'
import viVN from './locales/vi-VN'
import trTR from './locales/tr-TR'
import nlNL from './locales/nl-NL'
import idID from './locales/id-ID'
import heIL from './locales/he-IL'

const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'de-DE': deDE,
    'pt-PT': ptPT,
    'es-ES': esES,
    'fr-FR': frFR,
    'it-IT': itIT,
    'ru-RU': ruRU,
    'ko-KR': koKR,
    'ja-JP': jaJP,
    'ar-SA': arSA,
    'th-TH': thTH,
    'vi-VN': viVN,
    'tr-TR': trTR,
    'nl-NL': nlNL,
    'id-ID': idID,
    'he-IL': heIL
  }
})

export default i18n
